import AccessGroupsSettings from './AccessGroupsSettings';

export default AccessGroupsSettings;
